
import React, { useState, useEffect } from 'react'
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { addItem, removeItem, AddAllItem, removeOneCompleteItem, setCouponData } from '../../reducetool/features/cardSlice';
import { apiService } from '../../constants/ApiService';
import { toast } from 'react-toastify';


const Cart = ({ companyDetail }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const shoppingCart = useSelector(state => state.cardState);
    const authData = useSelector(state => state.authState);

    const [couponAppliedCode, setCouponAppliedCode] = useState(""); // NEW: Store applied code
    const [couponInputCode, setCouponInputCode] = useState(""); // for controlled input only
    const {
        couponCode,
        couponDiscount,
        grandTotal,
        subTotal,
        totalSavings,
        shippingCharges
    } = useSelector(state => state.cardState);



    const getAddToCartData = async () => {
        try {

            const response = await apiService.get(`/api/AddToCartMaster/addToCartByUserId`)
            if (response.response && response.response.data.errors) {
                console.log(response.response?.data?.errors)
            }
            console.log(response)
            if (response.status === true) {
                if (response.addToCartMasterData.length != 0) {
                    dispatch(AddAllItem(response.addToCartMasterData))
                }
            }
            else {
                console.log(response.message);
            }
        } catch (error) {
            console.log(error)
            alert('SomeThing went wrong!!');
        }


    }

    useEffect(() => {
        if (authData.login) {
            getAddToCartData()
        }
    }, [])


    const addSingleItemToCart = async (productId) => {
        try {

            const response = await apiService.get(`/api/AddToCartMaster/AddToCartOneItem?itemId=${productId}`);

            if (response.response && response.response.data.errors) {
                console.log(response.response?.data?.errors)
            }

            if (response.status === true) {
                console.log(response.message)
            }
            else {
                console.log(response.message);
            }
        } catch (error) {
            console.log(error)
            alert('SomeThing went wrong!!');
        }
    }

    const removeOneQty = async (productId) => {
        try {

            const response = await apiService.get(`/api/AddToCartMaster/RemoveOneQty?itemId=${productId}`);

            if (response.response && response.response.data.errors) {
                console.log(response.response?.data?.errors)
            }

            if (response.status === true) {
                console.log(response.message)
            }
            else {
                console.log(response.message);
            }
        } catch (error) {
            console.log(error)
            alert('SomeThing went wrong!!');
        }
    }

    const removeItemFromCart = async (productId) => {
        try {

            const response = await apiService.delete(`/api/AddToCartMaster/DeleteCartOneItem?itemId=${productId}`);

            if (response.response && response.response.data.errors) {
                console.log(response.response?.data?.errors)
            }

            if (response.status === true) {
                // console.log(response.message)
            }
            else {
                console.log(response.message);
            }
        } catch (error) {
            console.log(error)
            alert('SomeThing went wrong!!');
        }
    }


    const handleAddToCart = (product) => {

        if (authData.login) {
            addSingleItemToCart(product.product_id);
        }

        dispatch(addItem(product));
    };

    const handleRemoveOneQty = (product) => {
        // let filterArray = shoppingCart.items.find(data => {
        //     return data.product_id === itemId;
        // });

        if (authData.login) {
            removeOneQty(product.product_id);
        }
        dispatch(removeItem(product));
    };

    const handleRemoveItem = (product) => {
        if (authData.login) {
            removeItemFromCart(product.product_id);
        }

        dispatch(removeOneCompleteItem(product));
    };


    const GetLoginSession = async () => {
        try {


            const response = await apiService.get(`api/admin/User_Detail/LoginSession`);

            if (response.response && response.response.data.errors) {
                console.log(response);
                //alert(response.response?.data?.errors);
                return false;
            }

            if (response.status === true) {
                return true;
                navigate("/checkout");
            }
            else {
                return false;
                navigate("/login");
            }
        } catch (error) {
            //console.log(error, "errorerror")
            alert('SomeThing went wrong!!');
            return false;
        }
    }


    const gotoCheckout = async () => {
        const loggedIn = await GetLoginSession()
        if (!loggedIn) {
            toast.error("Please login to continue...");
            navigate("/login");
            return;
        }
        else {
            navigate("/checkout");
        }

    }

    useEffect(() => {
        let grossTotal = shoppingCart.items.reduce(
            (total, item) => total + (item.strike_sp * item.quantity),
            0
        );

        let baseSavings = shoppingCart.items.reduce(
            (total, item) => total + ((item.strike_sp - item.sp_after_tax) * item.quantity),
            0
        );

        let subTotal = grossTotal - baseSavings;
        let shipping = Number(subTotal) >= Number(companyDetail.free_shipping_order_amount || 0)
            ? 0
            : Number(companyDetail.standard_shipping_charges || 0);

        let totalSavings = baseSavings + Number(shoppingCart.couponDiscount || 0);
        let grandTotal = Number(subTotal) - Number(shoppingCart.couponDiscount || 0) + shipping;

        dispatch(setCouponData({
            couponCode: shoppingCart.couponCode,
            couponDiscount: shoppingCart.couponDiscount || 0,
            grandTotal: grandTotal,
            subTotal: subTotal,
            totalSavings: totalSavings,
            shippingCharges: shipping
        }));
    }, [shoppingCart.items, shoppingCart.couponCode, shoppingCart.couponDiscount, companyDetail]);


    const applyCoupon = async () => {
        try {
            const loggedIn = await GetLoginSession();
            if (!loggedIn) {
                toast.error("Please login to continue...");
                navigate("/login");
                return;
            }

            const response = await apiService.post(`/api/CouponMaster/apply-coupon`, {
                CouponCode: couponInputCode, // use local input state here
                CartTotal: subTotal,
            });

            if (response.isValid) {
                const grandTotal = subTotal - response.discountAmount + shippingCharges;

                // Dispatch updated values to Redux
                dispatch(setCouponData({
                    couponCode: couponInputCode,
                    couponDiscount: response.discountAmount,
                    grandTotal: grandTotal,
                    subTotal: subTotal,
                    totalSavings: totalSavings + response.discountAmount, // add discount to savings
                    shippingCharges: shippingCharges,
                }));
                setCouponAppliedCode(couponInputCode);

                toast.success(response.message);
            } else {
                toast.error(response.message);
            }
        } catch (error) {
            console.error("Coupon error:", error);
            toast.error("Something went wrong while applying the coupon.");
        }
    };


    const removeCoupon = () => {
        const grandTotal = subTotal + shippingCharges;

        dispatch(setCouponData({
            couponCode: "",
            couponDiscount: 0,
            grandTotal: grandTotal,
            subTotal: subTotal,
            totalSavings: totalSavings - couponDiscount,
            shippingCharges: shippingCharges,
        }));

        toast.info("Coupon removed.");
    };



    return (
        <>
            {/* Breadcrumb Section Start */}
            <section className="breadscrumb-section pt-0">
                <div className="container-fluid-lg">
                    <div className="row">
                        <div className="col-12">
                            <div className="breadscrumb-contain">
                                <h2>Cart</h2>
                                <nav>
                                    <ol className="breadcrumb mb-0">
                                        <li className="breadcrumb-item">
                                            <Link to="/">
                                                <i className="fa-solid fa-house" />
                                            </Link>
                                        </li>
                                        <li className="breadcrumb-item active" aria-current="page">
                                            Cart
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Breadcrumb Section End */}

            {/* Cart Section Start */}
            <section className="cart-section section-b-space">
                <div className="container-fluid-lg">
                    {shoppingCart.items.length != 0 ?
                        <div className="row g-sm-5 g-3">
                            <div className="col-xxl-9">
                                <div className="cart-table">

                                    <div className="table-responsive d-none d-sm-block">
                                        <table className="table">
                                            <tbody>
                                                {shoppingCart.items.length != 0 && shoppingCart?.items.map((product, index) => (
                                                    <tr key={index} className="product-box-contain">
                                                        <td className="product-detail">
                                                            <div className="product border-0">
                                                                <Link to={`/product-detail/${product.product_slug}/${product.product_id}`}
                                                                    state={{ productId: product.product_id, subcategoryName: product.product_sub_category }} className="product-image" >
                                                                    <img src={process.env.REACT_APP_API_BASE_URL + product.img_url} className="img-fluid lazyload" alt={product.name} />
                                                                </Link>
                                                                <div className="product-detail">
                                                                    <ul>
                                                                        <li className="name">
                                                                            <Link to={`/product-detail/${product.product_slug}/${product.product_id}`}
                                                                                state={{ productId: product.product_id, subcategoryName: product.product_sub_category }}>{product.product_title.substring(0, 20)}...</Link>
                                                                        </li>
                                                                        {/* <li className="text-content">
                                                                            <span className="text-title">Sold By:</span> {product.vender_name}
                                                                        </li> */}
                                                                        <li className="text-content">
                                                                            <span className="text-title">Quantity</span> - {product.quantity}
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className="price">
                                                            <h4 className="table-title text-content">Price</h4>
                                                            <h5>
                                                                ₹{product.sp_after_tax} <del className="text-content">₹{product.strike_sp}</del>
                                                            </h5>
                                                            <h6 className="theme-color">You Save : ₹{(product.strike_disc_amt) * product.quantity}</h6>
                                                        </td>
                                                        <td className="quantity">
                                                            <h4 className="table-title text-content">Qty</h4>
                                                            <div className="quantity-price">
                                                                <div className="cart_qty">
                                                                    <div className="input-group">
                                                                        <button
                                                                            type="button"
                                                                            className="btn qty-left-minus"
                                                                            data-type="minus"
                                                                            data-field=""
                                                                            onClick={() => handleRemoveOneQty(product)}

                                                                        >
                                                                            <i
                                                                                className="fa fa-minus ms-0"
                                                                                aria-hidden="true"
                                                                            />
                                                                        </button>
                                                                        <input
                                                                            className="form-control input-number qty-input"
                                                                            type="text"
                                                                            name="quantity"
                                                                            value={product.quantity}
                                                                        />
                                                                        <button
                                                                            type="button"
                                                                            className="btn qty-right-plus"
                                                                            data-type="plus"
                                                                            data-field=""
                                                                            onClick={() => handleAddToCart(product)}
                                                                        >
                                                                            <i
                                                                                className="fa fa-plus ms-0"
                                                                                aria-hidden="true"
                                                                            />
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className="subtotal">
                                                            <h4 className="table-title text-content">Total</h4>
                                                            <h5>Rs {product.quantity * product.sp_after_tax}</h5>
                                                        </td>
                                                        <td className="save-remove">
                                                            <h4 className="table-title text-content">Action</h4>
                                                            {/* <a
                                                                className="remove close_button"
                                                                href="javascript:void(0)"
                                                                onClick={()=>{dispatch(removeOneCompleteItem(product.product_id))}}
                                                            >
                                                                Remove
                                                            </a> */}
                                                            <button className="btn btn-sm btn-animation proceed-btn fw-bold"
                                                                onClick={() => { handleRemoveItem(product) }}
                                                            >Remove</button>
                                                        </td>
                                                    </tr>
                                                ))}

                                            </tbody>
                                        </table>
                                    </div>

                                    <div className="d-block d-sm-none">
                                        {shoppingCart.items.map((product, index) => (
                                            <div key={index} className="card mb-3 p-2 shadow-sm">
                                                <div className="d-flex gap-2">
                                                    <img
                                                        src={process.env.REACT_APP_API_BASE_URL + product.img_url}
                                                        alt={product.name}
                                                        style={{ width: 80, height: 80, objectFit: 'cover' }}
                                                    />
                                                    <div className="flex-grow-1">
                                                        <h6 className="mb-1">{product.product_title.substring(0, 30)}...</h6>
                                                        <p className="mb-1">Price: ₹{product.sp_after_tax} <del className="text-muted">₹{product.strike_sp}</del></p>
                                                        <p className="mb-1">You Save: ₹{product.strike_disc_amt * product.quantity}</p>
                                                        <p className="mb-1">Qty: {product.quantity}</p>
                                                        <div className="d-flex gap-2 align-items-center">
                                                            <button className="btn text-white theme-bg-color" onClick={() => handleRemoveOneQty(product)}>-</button>
                                                            <span>{product.quantity}</span>
                                                            <button className="btn text-white theme-bg-color" onClick={() => handleAddToCart(product)}>+</button>
                                                            <button className="btn btn-animation proceed-btn ms-auto" onClick={() => handleRemoveItem(product)}>Remove</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            <div className="col-xxl-3">
                                <div className="summery-box p-sticky">
                                    <div className="summery-header">
                                        <h3>Cart Total</h3>
                                    </div>
                                    <div className="summery-contain">
                                        <div className="coupon-cart">
                                            <h6 className="text-content mb-2">Coupon</h6>

                                            {couponCode ? (
                                                <div className="alert alert-success d-flex justify-content-between align-items-center inter-font">
                                                    <div>
                                                        <strong>{couponCode.toUpperCase()}</strong> applied — you saved ₹{couponDiscount}
                                                    </div>
                                                    <button className="btn btn-sm btn-danger" onClick={removeCoupon}>
                                                        <i className='fa fa-remove' />
                                                    </button>
                                                </div>
                                            ) : (
                                                <div className="mb-3 coupon-box input-group">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Coupon Code"
                                                        value={couponInputCode}
                                                        onChange={(e) => setCouponInputCode(e.target.value)}
                                                    />
                                                    <button className="btn-apply" onClick={applyCoupon}>Apply</button>
                                                </div>
                                            )}
                                        </div>
                                        <ul>
                                            {/* <li>
                                                <h4>Gross Total</h4>
                                                <h4 className="price">₹{GrossTotal}</h4>
                                            </li> */}

                                            <li>
                                                <h4>Cart Total</h4>
                                                <h4 className="price">₹{subTotal}</h4>
                                            </li>

                                            <li>
                                                <h4>Coupon Discount</h4>
                                                <h4 className="price">(-) ₹{couponDiscount}</h4>
                                            </li>
                                            <li className="align-items-start">
                                                <h4>Shipping</h4>
                                                <h4 className="price text-end">₹{shippingCharges}</h4>
                                            </li>
                                        </ul>
                                    </div>
                                    <ul className="summery-total">
                                        <li>
                                            <h4 className='theme-color'>Your Savings</h4>
                                            <h4 className="price theme-color">₹{totalSavings}</h4>
                                        </li>
                                        <li className="list-total border-top-0">
                                            <h4>Total (₹)</h4>
                                            <h4 className="price">₹{grandTotal}</h4>
                                        </li>
                                    </ul>
                                    <div className="button-group cart-button">
                                        <ul>
                                            <li>
                                                <button
                                                    onClick={() => { gotoCheckout() }}
                                                    className="btn btn-animation proceed-btn inter-font"
                                                >
                                                    Process To Checkout
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    onClick={() => { navigate("/") }}
                                                    className="btn btn-light shopping-button text-dark inter-font"
                                                >
                                                    <i className="fa-solid fa-arrow-left-long" />
                                                    Return To Shopping
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :

                        <div className="col-xxl-12">
                            <div className="summery-box p-sticky" style={{ padding: 20 }}>
                                <h3 style={{ textAlign: "center", marginTop: "20px", margin: 20 }}>Your shopping cart is currently empty.</h3>
                                <div className="button-group cart-button ">
                                    <ul>
                                        <li>
                                            <button
                                                onClick={() => { navigate("/") }}
                                                className="btn theme-bg-color shopping-button text-light"
                                            >
                                                <i className="fa-solid fa-arrow-left-long" />
                                                Return To Shopping
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </section>
            {/* Cart Section End */}
        </>

    )
}

export default Cart;